export interface TestType {
    name: string;
    age: number;
    designation?: string;
    address?: string[];
}

export interface ITableConfig {
    tableId: string;
    restaurantId: string;
    parentOrderId?: string;
}

export enum PinGenerationStatus {
    SUCCESS = "SUCCESS",
    PIN_ALREADY_GENERATED = "PIN_ALREADY_GENERATED",
    PIN_GENERATED_BY_OTHER_USER = "PIN_GENERATED_BY_OTHER_USER",
    FAILURE = "FAILURE",
    USER_VERIFIED = "USER_VERIFIED",
    TABLE_CLOSED = "TABLE_CLOSED",
    BILL_GENERATED = "BILL_GENERATED",
}

export enum RestaurantFlow {
    PIN = "PIN",
    PINLESS = "PINLESS",
}

export enum DigitalMenuVersion {
    V1 = "DIGITAL_MENU_VERSION_V1",
    V2 = "DIGITAL_MENU_VERSION_V2",
}

export enum MenuLayout {
    LAYOUT_1X1 = "MENU_LAYOUT_1X1",
    LAYOUT_2X2 = "MENU_LAYOUT_2X2",
}

export enum ConfigTheme {
    THEME_DIGITAL_MENU_BRAND_ORANGE = "DigitalMenuBrandOrange",
    THEME_DIGITAL_MENU_BRAND_BLUE = "DigitalMenuBrandBlue",
    THEME_DIGITAL_MENU_BRAND_GREEN = "DigitalMenuBrandGreen",
    THEME_DIGITAL_MENU_BRAND_BLACK = "DigitalMenuBrandBlack",
}

export interface IThemeInfo {
    theme: ConfigTheme;
}

export interface INudgeConfig {
    enabled: boolean;
    swiggyLogoEnabled?: boolean;
}

export interface IConversionNudgesConfig {
    enableConversionNudges: boolean;
    nudges: {
        payBillBottomNav?: INudgeConfig;
        toolTipOnMenu?: INudgeConfig;
        myOrdersPersistentComm?: INudgeConfig;
        halfCardOnMenu?: INudgeConfig;
        billSummaryPersistentComm?: INudgeConfig;
        doneDiningHalfCard?: INudgeConfig;
    };
}

export interface IDigitalMenuConfigData {
    restaurantId: string;
    version: DigitalMenuVersion;
    menuLayout: MenuLayout;
    themeInfo: IThemeInfo;
    updatedAt: number;
    conversionNudgesConfig?: IConversionNudgesConfig;
    isCoverCountEnabled?: boolean;
    isDelayedSuccessEnabled?: boolean;
    delayedSuccessTimeout?: number;
}

export enum ConfigLoadingStatus {
    IDLE = "IDLE",
    LOADING = "LOADING",
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
}
